import axios from "axios";

export const getResearchReports = (params) =>
    axios.get('research-reports', params)
        .then(({ data }) => data)
